// extracted by mini-css-extract-plugin
export default {"footer":"index_footer_9cpW9","foot_link":"index_foot_link_aNkYm","list":"index_list_uzo-N","link":"index_link_UgcCH","copyright":"index_copyright_UoCNY"};